import { del, EndPoints, get, post } from '../';
export function list() {
    return get(EndPoints.push, { all: 1 });
}
export function sendPush(request) {
    return post(EndPoints.pushSend, request);
}
export function deletePush(request) {
    return del("" + EndPoints.pushDelete, request);
}
